import { apiFetch } from './client';

// Mirrors GET /api/v1/organizations/{slug}/push-log* on the backend. Mirrors
// the email-log client shape so the Settings → Log → Push tab can re-use the
// same batch / recipient / preview controls.

export interface PushBatch {
  batch_id: string;
  kind: string;
  title_preview: string;
  body_preview: string;
  sent_at: string;
  total: number;
  sent_count: number;
  failed_count: number;
  skipped_count: number;
}

export type PushStatus = 'sent' | 'failed' | 'skipped';

export interface PushRecipient {
  id: string;
  user_id: string;
  display_name?: string;
  email?: string;
  platform?: string;
  status: PushStatus;
  reason: string;
  detail?: string;
  title: string;
  body: string;
  action_url?: string;
  created_at: string;
}

export interface PushPreview {
  id: string;
  display_name?: string;
  email?: string;
  platform?: string;
  status: PushStatus;
  title: string;
  body: string;
  action_url?: string;
  created_at: string;
}

export interface ListPushBatchesResponse {
  items: PushBatch[];
  total: number;
}

export interface ListPushRecipientsResponse {
  items: PushRecipient[];
}

interface ListBatchesOpts {
  from?: string;
  to?: string;
  kind?: string;
  limit?: number;
  offset?: number;
}

export async function listPushBatches(
  token: string | null,
  slug: string,
  opts: ListBatchesOpts = {},
): Promise<ListPushBatchesResponse> {
  const qs = new URLSearchParams();
  if (opts.from) qs.set('from', opts.from);
  if (opts.to) qs.set('to', opts.to);
  if (opts.kind) qs.set('kind', opts.kind);
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.offset) qs.set('offset', String(opts.offset));
  const query = qs.toString();
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/push-log${query ? `?${query}` : ''}`;
  return apiFetch<ListPushBatchesResponse>(path, { token });
}

export async function listPushRecipients(
  token: string | null,
  slug: string,
  batchId: string,
  q?: string,
): Promise<ListPushRecipientsResponse> {
  const query = q ? `?q=${encodeURIComponent(q)}` : '';
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/push-log/${encodeURIComponent(batchId)}/recipients${query}`;
  return apiFetch<ListPushRecipientsResponse>(path, { token });
}

export async function getPushPreview(
  token: string | null,
  slug: string,
  messageId: string,
): Promise<PushPreview> {
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/push-log/messages/${encodeURIComponent(messageId)}/preview`;
  return apiFetch<PushPreview>(path, { token });
}
